import { BrowserRouter, Route, Routes } from "react-router-dom";
import Admin from "../features/Admin/routes";
import LGRoute from "../features/LG/routes";
export default function Pages() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/*" element={<LGRoute />} />
          <Route path="admin/*" element={<Admin />} />
          <Route path="LP" element={<>lp</>} />
        </Routes>
      </BrowserRouter>
    </>
  );
}
